<script setup>
import { ref } from 'vue'
import DatePickerWithPriceBadge from "./DatePickerWithPriceBadge.vue";

const singleDate = ref(null)
const rangeDate = ref({ start: null, end: null })

// Ukázková priceMap s více měnami + barvami + tooltipem (note)
const priceMap = {
  '2025-09-01': { amount: 1200, currency: 'CZK', color: '#10b981', note: 'Promo pondělí' },
  '2025-09-02': { amount: 59, currency: 'EUR', color: '#0ea5e9', note: 'Speciální cena' },
  '2025-09-03': { amount: 75, currency: 'USD', color: '#f59e0b', note: 'Peak time' },
}

// Atributy v-calendar – dostupnost/disabled tak, jak jste zvyklí
const attributes = [
  // Příklad: zakázané dny (jen ukázka)
  // { key: 'blocked', dates: { start: '2025-09-10', end: '2025-09-12' }, excludeDates: [], highlight: { color: 'red' } },
]

// Disabled nebo available lze dál řídit přes props (forward)
const disabledDates = undefined
const availableDates = undefined
</script>

<template>
  <div class="p-4 space-y-10">
    <!-- SINGLE DATE + WEEK TOGGLE + CENY + 2 SLOUPCE -->
    <section>
      <h2 class="font-bold text-lg mb-2">Single date, 2 kalendáře, ceny, přepínač měsíc/týden</h2>
      <DatePickerWithPriceBadge
        v-model="singleDate"
        :columns="2"
        color="indigo"
        locale="cs"
        :first-day-of-week="1"
        :attributes="attributes"
        :disabled-dates="disabledDates"
        :available-dates="availableDates"
        :price-map="priceMap"
        default-currency="CZK"
        :enable-week-toggle="true"
        initial-view="month"
        title-position="center"
        style="max-width: 1100px"
      />
      <div class="mt-2 text-sm opacity-70">Vybráno: {{ singleDate }}</div>
    </section>

    <!-- RANGE DATE + BARVENÍ -->
    <section>
      <h2 class="font-bold text-lg mb-2">Range výběr (isRange), barva „emerald“, bez přepínače</h2>
      <DatePickerWithPriceBadge
        v-model="rangeDate"
        :is-range="true"
        color="emerald"
        locale="cs"
        :first-day-of-week="1"
        :price-map="priceMap"
        :enable-week-toggle="false"
        title-position="left"
        style="max-width: 540px"
      />
      <div class="mt-2 text-sm opacity-70">Vybráno: {{ rangeDate }}</div>
    </section>
  </div>
</template>

<style scoped>
</style>
